<template>
  <footer class="site-footer">
    <div class="site-footer__brand">
      <a class="site-footer__logo" href="/" :aria-label="links.homeLabel">
        <MascotLogo />
        <span>GuildGuardian</span>
      </a>
      <p>{{ links.copy }}</p>
      <div class="site-footer__socials" :aria-label="links.socialTitle">
        <a v-for="social in links.socials" :key="social.label" :href="social.href" :aria-label="social.label">
          <AppIcon :name="social.icon" />
        </a>
      </div>
      <small>{{ links.copyright }}</small>
    </div>

    <nav class="site-footer__columns" :aria-label="links.navigationLabel">
      <section v-for="column in links.columns" :key="column.title">
        <h2>{{ column.title }}</h2>
        <a v-for="link in column.links" :key="link.label" :href="link.href">
          <span>{{ link.label }}</span>
          <em v-if="link.badge">{{ link.badge }}</em>
        </a>
      </section>
    </nav>

    <div class="site-footer__bottom">
      <a href="#top">
        <AppIcon name="chevron" />
        <span>{{ links.backToTop }}</span>
      </a>
    </div>
  </footer>
</template>

<script>
import AppIcon from './AppIcon.vue'
import MascotLogo from './MascotLogo.vue'

export default {
  name: 'SiteFooter',
  components: {
    AppIcon,
    MascotLogo
  },
  props: {
    links: {
      type: Object,
      required: true
    }
  }
}
</script>
